// Type-only throughout: the interface and the input shape live beside the
// repository-backed query, which reaches for `@telespot/domain` repositories the
// browser must never pull in. A value import here would drag that module edge
// into the bundle.
import type { LabelUsageDto } from '../../dtos/label-usage.dto';
import type { ILabelUsagePort } from '../../ports/label-usage.port';

import type { IListLabelUsageQuery, ListLabelUsageInput } from './list-label-usage.use-case';

/**
 * The label-usage read as the browser gets it: over the port, which reaches the
 * `listLabelUsage` cloud function. A deliberate pass-through — the UI depends on
 * `IListLabelUsageQuery` alone, so it is blind to which side of the wire the
 * read runs on, and never depends on a port.
 */
export class APIListLabelUsageQuery implements IListLabelUsageQuery {
  constructor(private readonly labelUsagePort: ILabelUsagePort) {}

  public execute(input: ListLabelUsageInput): Promise<LabelUsageDto[]> {
    return this.labelUsagePort.list(input.labelUuid);
  }
}
